import { Component } from '@angular/core';

@Component({
  selector: 'sociuu-sociuuhub',
  templateUrl: './sociuuhub.component.html',
  styleUrls: ['./sociuuhub.component.scss']
})
export class SociuuhubComponent {

  constructor() { }
}
